import React from 'react';
import PropTypes from 'prop-types';

import { faPenToSquare } from '@fortawesome/pro-solid-svg-icons';

import Button from 'shared/button';
import StageLabel from './stage_label';

export default function Stage({ stage, onClick }) {
  const showCloseProbability = stage.defaultCloseProbability || stage.defaultCloseProbability === 0;
  const value = showCloseProbability ? stage.defaultCloseProbability : '--';

  return (
    <div className="stages-settings__stage-overview">
      <div>
        <StageLabel stage={stage} />
        <div className="d-flex gap-2 align-items-center">
          <span>Default Close Probability: {value}%</span>
          <Button.Secondary icon={faPenToSquare} plain onClick={onClick}>
            Edit
          </Button.Secondary>
        </div>
      </div>
    </div>
  );
}

Stage.propTypes = {
  stage: PropTypes.object,
  onClick: PropTypes.func.isRequired,
};
